"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePatientTefcaProviderInput = exports.UpdatePatientInput = exports.UpdateTestPatientConsentResponseDto = exports.UpdateTestPatientConsentInput = exports.TestPatientConsentStatus = exports.UpdateTestPatientResponseDto = exports.UpdateTestPatientInput = exports.TestPatientResponseDto = exports.TestPatientDto = exports.CreateTestPatientInput = exports.PatientDeleteAccountInput = exports.PatientAccountDeletionRequestReasonType = exports.PatientMappingDto = exports.ProxyAccessDto = exports.RelatedPersonDto = exports.PatientNudgeNotificationInput = exports.PatientGeneralNotificationInput = exports.PatientRecordRetrievalNotificationInput = exports.PatientStudyNotificationInput = exports.PatientConsentNotificationInput = exports.PatientNotificationInput = exports.PatientBaseNotificationWithOptionalOrganizationInput = exports.PatientBaseNotificationInput = exports.PatientNudgeNotificationType = exports.PatientGeneralNotificationType = exports.PatientRecordRetrievalNotificationType = exports.externalResearcherSupportedPatientStudyNotificationTypes = exports.PatientStudyNotificationType = exports.externalResearcherSupportedPatientConsentNotificationTypes = exports.PatientConsentNotificationType = exports.PatientSearchDto = exports.GlobalPatientReference = exports.PatientRequestReminderSendType = exports.PatientGuidedConsentsDto = exports.PatientGuidedConsentUpdate = exports.PatientGuidedConsentDto = exports.PatientDto = void 0;
exports.updateConsentNotificationTypeIfNeeded = updateConsentNotificationTypeIfNeeded;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const notification_dtos_1 = require("./notification.dtos");
const consentconfig_dtos_1 = require("./consentconfig.dtos");
const study_translation_language_dtos_1 = require("./study-translation-language.dtos");
const swagger_1 = require("@nestjs/swagger");
const document_retrieval_dtos_1 = require("./document.retrieval.dtos");
const features_dtos_1 = require("./features.dtos");
class PatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientDto = PatientDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientDto.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientDto.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientDto.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PatientDto.prototype, "age", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], PatientDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientDto.prototype, "mrn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], PatientDto.prototype, "phoneVerified", void 0);
class PatientGuidedConsentDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientGuidedConsentDto = PatientGuidedConsentDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "healthcareOrganizationId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "healthExPatientId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "mrn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "state", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientGuidedConsentDto.prototype, "birthDate", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], PatientGuidedConsentDto.prototype, "lastAccessed", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentDto.prototype, "language", void 0);
class PatientGuidedConsentUpdate {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientGuidedConsentUpdate = PatientGuidedConsentUpdate;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "healthExPatientId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "mrn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "state", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientGuidedConsentUpdate.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientGuidedConsentUpdate.prototype, "language", void 0);
class PatientGuidedConsentsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientGuidedConsentsDto = PatientGuidedConsentsDto;
__decorate([
    (0, class_transformer_1.Type)(() => PatientGuidedConsentDto),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], PatientGuidedConsentsDto.prototype, "patients", void 0);
var PatientRequestReminderSendType;
(function (PatientRequestReminderSendType) {
    PatientRequestReminderSendType["INITIAL"] = "INITIAL";
    PatientRequestReminderSendType["AUTOMATED_REMINDER"] = "AUTOMATED_REMINDER";
    PatientRequestReminderSendType["MANUAL_REMINDER"] = "MANUAL_REMINDER";
})(PatientRequestReminderSendType || (exports.PatientRequestReminderSendType = PatientRequestReminderSendType = {}));
class GlobalPatientReference {
}
exports.GlobalPatientReference = GlobalPatientReference;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "organizationId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "patientId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "mrn", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], GlobalPatientReference.prototype, "noDataAccess", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(PatientRequestReminderSendType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], GlobalPatientReference.prototype, "patientRequestReminderSendType", void 0);
class PatientSearchDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientSearchDto = PatientSearchDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "patientId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "mrn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "state", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientSearchDto.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PatientSearchDto.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PatientSearchDto.prototype, "age", void 0);
var PatientConsentNotificationType;
(function (PatientConsentNotificationType) {
    PatientConsentNotificationType["REVOKE_PRESCREEN"] = "REVOKE_PRESCREEN";
    PatientConsentNotificationType["REVOKE_ENROLLMENT"] = "REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["AI_DATA_USE_REVOKE_ENROLLMENT"] = "AI_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REVOKE_ENROLLMENT"] = "PDDE_RESEARCH_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["DECLINE_PRESCREEN"] = "DECLINE_PRESCREEN";
    PatientConsentNotificationType["DECLINE_ENROLLMENT"] = "DECLINE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_DECLINE_ENROLLMENT"] = "PDDE_DECLINE_ENROLLMENT";
    PatientConsentNotificationType["AI_DATA_USE_DECLINE_ENROLLMENT"] = "AI_DATA_USE_DECLINE_ENROLLMENT";
    PatientConsentNotificationType["PRESCREEN_CONFIRMATION"] = "PRESCREEN_CONFIRMATION";
    PatientConsentNotificationType["ENROLLMENT_CONFIRMATION"] = "ENROLLMENT_CONFIRMATION";
    PatientConsentNotificationType["REQUEST_PRESCREEN"] = "REQUEST_PRESCREEN";
    PatientConsentNotificationType["REMINDER_PRESCREEN"] = "REMINDER_PRESCREEN";
    PatientConsentNotificationType["DEIDENTIFIED"] = "DEIDENTIFIED";
    PatientConsentNotificationType["REQUEST_ENROLLMENT"] = "REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REQUEST_ENROLLMENT"] = "PDDE_RESEARCH_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["REMINDER_ENROLLMENT"] = "REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REMINDER_ENROLLMENT"] = "PDDE_RESEARCH_REMINDER_ENROLLMENT";
})(PatientConsentNotificationType || (exports.PatientConsentNotificationType = PatientConsentNotificationType = {}));
exports.externalResearcherSupportedPatientConsentNotificationTypes = new Set([
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_DECLINE_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT,
]);
function updateConsentNotificationTypeIfNeeded(notificationType, isPdda, isGeneralDataUse, isAiDataUse) {
    if (!isPdda)
        return notificationType;
    if (notificationType === PatientConsentNotificationType.REQUEST_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REMINDER_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.DECLINE_ENROLLMENT) {
        return isAiDataUse
            ? PatientConsentNotificationType.AI_DATA_USE_DECLINE_ENROLLMENT
            : PatientConsentNotificationType.PDDE_DECLINE_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REVOKE_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT
            : isAiDataUse
                ? PatientConsentNotificationType.AI_DATA_USE_REVOKE_ENROLLMENT
                : PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT;
    }
    else {
        return notificationType;
    }
}
var PatientStudyNotificationType;
(function (PatientStudyNotificationType) {
    PatientStudyNotificationType["WITHDRAWN"] = "WITHDRAWN";
    PatientStudyNotificationType["REMOVED_ENROLLED"] = "REMOVED_ENROLLED";
    PatientStudyNotificationType["RE_ADDED"] = "RE_ADDED";
    PatientStudyNotificationType["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    PatientStudyNotificationType["PDDE_RESEARCH_UPDATE_RECORDS"] = "PDDE_RESEARCH_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS"] = "PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_RESEARCH_RECORDS_UPDATED"] = "PDDE_RESEARCH_RECORDS_UPDATED";
})(PatientStudyNotificationType || (exports.PatientStudyNotificationType = PatientStudyNotificationType = {}));
exports.externalResearcherSupportedPatientStudyNotificationTypes = new Set([
    PatientStudyNotificationType.WITHDRAWN,
    PatientStudyNotificationType.REMOVED_ENROLLED,
    PatientStudyNotificationType.RE_ADDED,
    PatientStudyNotificationType.PDDE_RESEARCH_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_RESEARCH_RECORDS_UPDATED,
]);
var PatientRecordRetrievalNotificationType;
(function (PatientRecordRetrievalNotificationType) {
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_UPDATE"] = "PDDE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_INITIAL"] = "PDDE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["PDDE_NO_RECORDS"] = "PDDE_NO_RECORDS";
    PatientRecordRetrievalNotificationType["IAS_RECORDS_FOUND"] = "IAS_RECORDS_FOUND";
    PatientRecordRetrievalNotificationType["IAS_NO_RECORDS"] = "IAS_NO_RECORDS";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_INITIAL"] = "AI_DATA_USE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_UPDATE"] = "AI_DATA_USE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_NO_RECORDS"] = "AI_DATA_USE_NO_RECORDS";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_VECTORIZATION_FAILED"] = "AI_DATA_USE_VECTORIZATION_FAILED";
})(PatientRecordRetrievalNotificationType || (exports.PatientRecordRetrievalNotificationType = PatientRecordRetrievalNotificationType = {}));
var PatientGeneralNotificationType;
(function (PatientGeneralNotificationType) {
    PatientGeneralNotificationType["ACCOUNT_DELETION_CONFIRMATION"] = "ACCOUNT_DELETION_CONFIRMATION";
    PatientGeneralNotificationType["VERIFICATION"] = "VERIFICATION";
})(PatientGeneralNotificationType || (exports.PatientGeneralNotificationType = PatientGeneralNotificationType = {}));
var PatientNudgeNotificationType;
(function (PatientNudgeNotificationType) {
    PatientNudgeNotificationType["CLEAR_DROPOFF"] = "CLEAR_DROPOFF";
    PatientNudgeNotificationType["DEMOGRAPHICS_DROPOFF"] = "DEMOGRAPHICS_DROPOFF";
    PatientNudgeNotificationType["CONSENT_DROPOFF"] = "CONSENT_DROPOFF";
    PatientNudgeNotificationType["RECORD_RETRIEVAL_DROPOFF"] = "RECORD_RETRIEVAL_DROPOFF";
})(PatientNudgeNotificationType || (exports.PatientNudgeNotificationType = PatientNudgeNotificationType = {}));
class PatientBaseNotificationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientBaseNotificationInput = PatientBaseNotificationInput;
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], PatientBaseNotificationInput.prototype, "patientIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "organizationId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientBaseNotificationInput.prototype, "organizationName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientBaseNotificationInput.prototype, "organizationLogoUrl", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => notification_dtos_1.NotificationAttachment),
    __metadata("design:type", Array)
], PatientBaseNotificationInput.prototype, "attachments", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(consentconfig_dtos_1.ContactMethod),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", typeof (_f = typeof consentconfig_dtos_1.ContactMethod !== "undefined" && consentconfig_dtos_1.ContactMethod) === "function" ? _f : Object)
], PatientBaseNotificationInput.prototype, "patientContactMethod", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(study_translation_language_dtos_1.StudyTranslationLanguage),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", typeof (_g = typeof study_translation_language_dtos_1.StudyTranslationLanguage !== "undefined" && study_translation_language_dtos_1.StudyTranslationLanguage) === "function" ? _g : Object)
], PatientBaseNotificationInput.prototype, "patientLanguage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientBaseNotificationInput.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => notification_dtos_1.PatientLanguageSwitchUrls),
    __metadata("design:type", typeof (_h = typeof notification_dtos_1.PatientLanguageSwitchUrls !== "undefined" && notification_dtos_1.PatientLanguageSwitchUrls) === "function" ? _h : Object)
], PatientBaseNotificationInput.prototype, "patientLanguageSwitchUrls", void 0);
class PatientBaseNotificationWithOptionalOrganizationInput extends (0, swagger_1.OmitType)(PatientBaseNotificationInput, [
    "organizationId",
    "organizationName",
    "organizationLogoUrl",
]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientBaseNotificationWithOptionalOrganizationInput = PatientBaseNotificationWithOptionalOrganizationInput;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationLogoUrl", void 0);
class PatientNotificationInput extends PatientBaseNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientNotificationInput = PatientNotificationInput;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientNotificationInput.prototype, "studyId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientNotificationInput.prototype, "aiAgentName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientNotificationInput.prototype, "aiChatbotUrl", void 0);
class PatientConsentNotificationInput extends (0, swagger_1.OmitType)(PatientNotificationInput, ["patientIds"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientConsentNotificationInput = PatientConsentNotificationInput;
__decorate([
    (0, class_validator_1.IsEnum)(PatientConsentNotificationType),
    __metadata("design:type", String)
], PatientConsentNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    (0, class_validator_1.IsObject)({ each: true }),
    __metadata("design:type", Array)
], PatientConsentNotificationInput.prototype, "patientIds", void 0);
class PatientStudyNotificationInput extends PatientNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientStudyNotificationInput = PatientStudyNotificationInput;
__decorate([
    (0, class_validator_1.IsEnum)(PatientStudyNotificationType),
    __metadata("design:type", String)
], PatientStudyNotificationInput.prototype, "patientNotificationType", void 0);
class PatientRecordRetrievalNotificationInput extends (0, swagger_1.OmitType)(PatientNotificationInput, ["studyId"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientRecordRetrievalNotificationInput = PatientRecordRetrievalNotificationInput;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientRecordRetrievalNotificationInput.prototype, "studyId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(PatientRecordRetrievalNotificationType),
    __metadata("design:type", String)
], PatientRecordRetrievalNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(document_retrieval_dtos_1.DocumentRetrievalOrigin),
    __metadata("design:type", typeof (_j = typeof document_retrieval_dtos_1.DocumentRetrievalOrigin !== "undefined" && document_retrieval_dtos_1.DocumentRetrievalOrigin) === "function" ? _j : Object)
], PatientRecordRetrievalNotificationInput.prototype, "documentRetrievalOrigin", void 0);
class PatientGeneralNotificationInput extends PatientBaseNotificationWithOptionalOrganizationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientGeneralNotificationInput = PatientGeneralNotificationInput;
__decorate([
    (0, class_validator_1.IsEnum)(PatientGeneralNotificationType),
    __metadata("design:type", String)
], PatientGeneralNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientGeneralNotificationInput.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientGeneralNotificationInput.prototype, "minutes", void 0);
class PatientNudgeNotificationInput extends PatientBaseNotificationWithOptionalOrganizationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.PatientNudgeNotificationInput = PatientNudgeNotificationInput;
__decorate([
    (0, class_validator_1.IsEnum)(PatientNudgeNotificationType),
    __metadata("design:type", String)
], PatientNudgeNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientNudgeNotificationInput.prototype, "resumeUrl", void 0);
class RelatedPersonDto {
}
exports.RelatedPersonDto = RelatedPersonDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RelatedPersonDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RelatedPersonDto.prototype, "lastName", void 0);
class ProxyAccessDto {
}
exports.ProxyAccessDto = ProxyAccessDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], ProxyAccessDto.prototype, "isEnabled", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => RelatedPersonDto),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], ProxyAccessDto.prototype, "relatedPerson", void 0);
class PatientMappingDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientMappingDto = PatientMappingDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PatientMappingDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientMappingDto.prototype, "dateOfBirth", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], PatientMappingDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", typeof (_l = typeof Date !== "undefined" && Date) === "function" ? _l : Object)
], PatientMappingDto.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], PatientMappingDto.prototype, "isSandbox", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], PatientMappingDto.prototype, "phoneVerified", void 0);
var PatientAccountDeletionRequestReasonType;
(function (PatientAccountDeletionRequestReasonType) {
    PatientAccountDeletionRequestReasonType["NO_LONGER_USE"] = "NO_LONGER_USE";
    PatientAccountDeletionRequestReasonType["PRIVACY_CONCERNS"] = "PRIVACY_CONCERNS";
    PatientAccountDeletionRequestReasonType["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
    PatientAccountDeletionRequestReasonType["OTHER"] = "OTHER";
})(PatientAccountDeletionRequestReasonType || (exports.PatientAccountDeletionRequestReasonType = PatientAccountDeletionRequestReasonType = {}));
class PatientDeleteAccountInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.PatientDeleteAccountInput = PatientDeleteAccountInput;
__decorate([
    (0, class_validator_1.IsEnum)(PatientAccountDeletionRequestReasonType),
    __metadata("design:type", String)
], PatientDeleteAccountInput.prototype, "deletedReasonType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], PatientDeleteAccountInput.prototype, "deletedReasonMessage", void 0);
class CreateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.CreateTestPatientInput = CreateTestPatientInput;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "First name of the test patient. Defaults to 'Test' if not provided.",
        example: "Test",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Last name of the test patient. Defaults to 'Patient' if not provided.",
        example: "Patient",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTestPatientInput.prototype, "dateOfBirth", void 0);
class TestPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.TestPatientDto = TestPatientDto;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the test patient",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Auto-generated email address in format test-patient+[random]@[org-domain]",
        example: "test-patient+dqKVeMid8N41@example.com",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "email", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "First name of the test patient",
        example: "Test",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "firstName", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last name of the test patient",
        example: "Patient",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "lastName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date of birth in ISO format",
        example: "1990-01-15",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TestPatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the organization this test patient belongs to",
        example: "658ac9e4-2a8b-4775-a58f-06ef6d65d914",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientDto.prototype, "organizationId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Timestamp when the test patient was created",
        example: "2026-01-31T01:52:05.653Z",
    }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", typeof (_m = typeof Date !== "undefined" && Date) === "function" ? _m : Object)
], TestPatientDto.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates this is a test patient",
        example: true,
    }),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TestPatientDto.prototype, "isTestPatient", void 0);
class TestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.TestPatientResponseDto = TestPatientResponseDto;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Auto-generated password. This is only returned once at creation time and cannot be retrieved later.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TestPatientResponseDto.prototype, "password", void 0);
class UpdateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.UpdateTestPatientInput = UpdateTestPatientInput;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "New first name for the test patient",
        example: "TestUpdated",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "New last name for the test patient",
        example: "PatientUpdated",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "New date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Set to true to generate a new random password",
        example: true,
    }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], UpdateTestPatientInput.prototype, "regeneratePassword", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Set a specific password instead of generating one",
        example: "MyCustomPassword123!",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientInput.prototype, "password", void 0);
class UpdateTestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
exports.UpdateTestPatientResponseDto = UpdateTestPatientResponseDto;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "New password if regeneratePassword was true or password was provided. Not included if password was not changed.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientResponseDto.prototype, "password", void 0);
var TestPatientConsentStatus;
(function (TestPatientConsentStatus) {
    TestPatientConsentStatus["OPTED_IN"] = "OPTED_IN";
    TestPatientConsentStatus["OPTED_OUT"] = "OPTED_OUT";
})(TestPatientConsentStatus || (exports.TestPatientConsentStatus = TestPatientConsentStatus = {}));
class UpdateTestPatientConsentInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.UpdateTestPatientConsentInput = UpdateTestPatientConsentInput;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Consent status - OPTED_IN to grant consent, OPTED_OUT to revoke consent",
        enum: TestPatientConsentStatus,
        enumName: "TestPatientConsentStatus",
        example: TestPatientConsentStatus.OPTED_IN,
    }),
    (0, class_validator_1.IsEnum)(TestPatientConsentStatus),
    __metadata("design:type", String)
], UpdateTestPatientConsentInput.prototype, "consentStatus", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Reason for revocation (only applicable when consentStatus is OPTED_OUT)",
        example: "Testing revocation flow",
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTestPatientConsentInput.prototype, "revocationReason", void 0);
class UpdateTestPatientConsentResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.UpdateTestPatientConsentResponseDto = UpdateTestPatientConsentResponseDto;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the consent record that was created or updated",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateTestPatientConsentResponseDto.prototype, "consentRecordId", void 0);
class UpdatePatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.UpdatePatientInput = UpdatePatientInput;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdatePatientInput.prototype, "phone", void 0);
class UpdatePatientTefcaProviderInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
exports.UpdatePatientTefcaProviderInput = UpdatePatientTefcaProviderInput;
__decorate([
    (0, class_validator_1.IsEnum)(features_dtos_1.TefcaProvider),
    __metadata("design:type", typeof (_o = typeof features_dtos_1.TefcaProvider !== "undefined" && features_dtos_1.TefcaProvider) === "function" ? _o : Object)
], UpdatePatientTefcaProviderInput.prototype, "provider", void 0);
